import { Dictionary } from '@feedyou/utils'

export const attachToWindow = (obj: Dictionary<string | number, any>) => {
  Object.keys(obj).forEach(key => {
    ;(window as any)[key] = obj[key]
  })
}
